import { useCallback } from 'react';

export default function Hero() {
  const handleScroll = useCallback((e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    const el = document.querySelector(target);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[720px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20colorful%20comic%20panel%20texture%20background%20with%20warm%20coral%20and%20golden%20gradients%2C%20soft%20geometric%20overlay%2C%20modern%20Korean%20webtoon%20aesthetic%2C%20clean%20artistic%20composition%2C%20subtle%20pattern%2C%20warm%20ambient%20tones%2C%20high%20resolution%20editorial%20design%20background&width=1600&height=900&seq=hero-bg-kr-comics&orientation=landscape"
          alt="韩国漫画网"
          className="w-full h-full object-cover object-top"
          style={{ filter: 'brightness(0.55) saturate(0.8)' }}
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/25"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="w-full lg:w-[55%] pt-28 md:pt-24 pb-8 md:pb-0">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent-500/90 backdrop-blur-sm rounded-full mb-5">
              <i className="ri-fire-line text-background-50 text-sm"></i>
              <span className="text-sm font-medium text-background-50 whitespace-nowrap">
                今日更新 2,847 话
              </span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-[3.35rem] font-bold text-background-50 leading-tight mb-5">
              韩国漫画网
              <span className="block text-xl sm:text-2xl md:text-3xl lg:text-[2rem] font-normal mt-2 text-background-50/90">
                韩国漫画网站大全 · 免费韩漫在线看
              </span>
            </h1>

            <p className="text-background-50/85 text-base md:text-lg leading-relaxed max-w-[560px] mb-4">
              韩国漫画网汇聚全网优质韩漫资源，为您提供一站式免费韩漫在线阅读入口。涵盖恋爱、奇幻、动作、悬疑、校园等全品类韩漫，支持下拉式流畅阅读体验，热门漫画实时追更，日更不断更，是韩漫爱好者不可错过的韩国漫画网站大全平台。
            </p>
            <p className="text-background-50/75 text-sm md:text-base leading-relaxed max-w-[560px] mb-7">
              本周热门专题「穿越重生」系列韩漫热度飙升，多部高分新作上线，快来探索你的下一部心头好。
            </p>

            <div className="flex flex-wrap items-center gap-6 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/15 backdrop-blur-sm">
                  <i className="ri-bookmark-line text-background-50 text-lg"></i>
                </div>
                <div>
                  <p className="text-background-50 text-lg font-bold leading-none">12,000+</p>
                  <p className="text-background-50/65 text-xs mt-1">韩漫资源</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/15 backdrop-blur-sm">
                  <i className="ri-user-smile-line text-background-50 text-lg"></i>
                </div>
                <div>
                  <p className="text-background-50 text-lg font-bold leading-none">380万+</p>
                  <p className="text-background-50/65 text-xs mt-1">月活读者</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/15 backdrop-blur-sm">
                  <i className="ri-time-line text-background-50 text-lg"></i>
                </div>
                <div>
                  <p className="text-background-50 text-lg font-bold leading-none">每日更新</p>
                  <p className="text-background-50/65 text-xs mt-1">从不间断</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-4">
              <a
                href="#carousel"
                onClick={(e) => handleScroll(e, '#carousel')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 bg-primary-500 text-background-50 font-semibold text-base rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
              >
                <i className="ri-rocket-2-line text-lg"></i>
                立即探索热门韩漫
              </a>
              <a
                href="#index"
                onClick={(e) => handleScroll(e, '#index')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 bg-background-50/15 backdrop-blur-sm text-background-50 font-medium text-base rounded-full border border-background-50/25 hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-grid-line text-lg"></i>
                分类浏览
              </a>
            </div>
          </div>

          <div className="w-full lg:w-[45%] flex items-center justify-center pb-8 lg:pb-0 lg:pt-20">
            <div className="relative w-full max-w-[420px] aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl shadow-black/30">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20style%20illustration%20of%20a%20stylish%20young%20character%20reading%20comics%20on%20a%20tablet%2C%20colorful%20comic%20panels%20floating%20around%2C%20warm%20vibrant%20color%20palette%20with%20coral%20and%20golden%20accents%2C%20clean%20artistic%20composition%2C%20editorial%20quality%2C%20dramatic%20lighting%2C%20immersive%20atmosphere&width=840&height=1120&seq=hero-main-kr-comic&orientation=portrait"
                alt="韩国漫画在线阅读 - 沉浸式韩漫阅读体验"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute top-4 right-4 flex items-center gap-2 px-3 py-1.5 bg-background-50/90 backdrop-blur-sm rounded-full">
                <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                <span className="text-xs font-medium text-foreground-900 whitespace-nowrap">连载中</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:block animate-bounce">
        <a
          href="#carousel"
          onClick={(e) => handleScroll(e, '#carousel')}
          className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 cursor-pointer hover:bg-background-50/30 transition-colors"
        >
          <i className="ri-arrow-down-line text-lg"></i>
        </a>
      </div>
    </section>
  );
}